import { createAsyncThunk } from '@reduxjs/toolkit';
import { AddOnProduct } from '../../../client/services';
import { toastHandler } from '../../../utils/toastHandler';
import { CreatePatchAddOnProduct, FindAddOnProduct, GetAddOnProduct } from './interface';

export const findAddOnProduct = createAsyncThunk(
  'addOnProduct/findAddOnProduct',
  async (values: FindAddOnProduct, { rejectWithValue }) => {
    try {
      const response = await AddOnProduct.find({
        query: values,
      });

      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const createAddOnProduct = createAsyncThunk(
  'addOnProduct/createAddOnProduct',
  async (values: CreatePatchAddOnProduct, { rejectWithValue }) => {
    try {
      const response = await AddOnProduct.create(values);
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const patchAddOnProduct = createAsyncThunk(
  'addOnProduct/patchAddOnProduct',
  async ({ id, ...values }: CreatePatchAddOnProduct, { rejectWithValue }) => {
    try {
      const response = await AddOnProduct.patch(id, values);
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const getAddOnProduct = createAsyncThunk(
  'addOnProduct/getAddOnProduct',
  async ({ id }: GetAddOnProduct, { rejectWithValue }) => {
    try {
      const response = await AddOnProduct.get(id);

      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);